import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
  },

  /*************
   * POST INFO *
   *************/
  postMetaContainer: {
    width: '100%',
  },
  featuredPostMetaContainer: {
    alignItems: 'center',
    textAlign: 'center',
  },

  spacedRow: {
    flex: 1,
    width: '100%',
    alignItems: 'flex-start',
  },
  featureMetaStack: {
    alignSelf: 'center',
    alignItems: 'center',
    width: '100%',
  },

  contentLabelWrapper: {
    lineHeight: 0,
    flexShrink: 0,
  },
  categoryWrapper: {
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center',
    '& .MuiLink-root': {
      lineHeight: 1,
    },
  },

  postMetaTitleSubContainer: {
    width: '100%',
    '& .MuiTypography-root': {
      lineHeight: 1.4,
    },
  },
  authorContainer: {
    alignItems: 'center',
  },
  italics: {
    fontStyle: 'italic',
  },

  categoryLink: {
    color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
  },
  titleLink: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
  authorLink: {
    color: theme.palette.text.primary,
  },
}));
